import AddReimbursement from "../../../../components/company/expense/reimbursement-claims/AddReimbursementClaim";

export default function AddReimbursementPage(){
    return <AddReimbursement/>
}